<template>
  <div class="container">
    <div class="result">
      <component :is="currentResult" />
    </div>
  </div>
</template>

<script>
import success from './components/invoice-success'
import fail from './components/invoice-fail'
// import wait from './components/invoice-wait'
import { Image, Row, Col, Dialog, Card, Tag } from 'vant'
export default {
  name: 'ReservationResult',
  components: {
    success,
    fail,
    // wait,
    [Image.name]: Image,
    [Row.name]: Row,
    [Col.name]: Col,
    [Card.name]: Card,
    [Tag.name]: Tag,
    [Dialog.Component.name]: Dialog.Component
  },
  data () {
    return {
      currentResult: 'success',
    }
  },
  created () {
    this.ScreeningPayResultType(this.$route.query.result)
  },
  mounted () {
    //阻止后退的所有动作，包括 键盘、鼠标手势等产生的后退动作。
    history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, window.location.href);
    });

  },
  destroyed () {  // 销毁时取消监听
    window.removeEventListener('popstate', this.fun, false);//false阻止默认事件
  },
  methods: {
    // 甄别支付回调类型
    ScreeningPayResultType (item) {
      this.currentResult = item
    },

  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;

  .action_bar {
    width: 100%;
    height: 20vh;
    padding: 20px 0 20px;

    &__suning {
      /deep/ .van-card {
        font-size: 16px;
        font-family: PingFang-SC-Medium;
        letter-spacing: 1.25px;
        font-weight: bold;
        background-color: #ffffff;

        /deep/ .order_tag {
          margin-top: 20px;
          display: flex;
          justify-content: flex-end;

          /deep/ .van-tag {
            font-size: 12px;
          }
        }

        /deep/ .van-card__bottom {
          display: flex;
          justify-content: flex-end;

          /deep/ .van-card__price {
            font-size: 14px;
          }

          /deep/ .van-card__origin-price {
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>